jQuery(document).ready(function ($) {
  // --- Filter Functionality ---
  if ($('#types-select').length) {
    $('#types-select').select2({
      placeholder: 'Choisissez un ou plusieurs formats (fiche, jeu, livret, etc.)',
      allowClear: true,
      dropdownParent: $('.select-wrap'),
    });
    updateActiveFilters();
  }

  $(document).on('click', '#search-btn', updateActiveFilters);
  $(document).on('click', '.remove-filter', function () {
    removeFilter($(this).data('type'));
  });
  $(document).on('click', '.remove-keyword', removeKeyword);
  $(document).on('click', '#reset-filters', function (e) {
    e.preventDefault();
    $('#types-select').val(null).trigger('change');
    $('#keyword-input').val('');
    updateActiveFilters();
    $('#search-btn').trigger('click');
  });

  function updateActiveFilters() {
    const activeFiltersList = $('.active-filters-list').empty();
    const selectedTypes = $('#types-select').select2('data');
    const keyword = $('#keyword-input').val().trim();

    selectedTypes.forEach(type => {
      activeFiltersList.append(
        `<div class="filter-tag">${type.text} <button type="button" class="remove-filter" data-type="${type.id}"><img src="${theme_vars.template_directory}/assets/images/icons/x.svg" alt="Remove filter"></button></div>`
      );
    });

    if (keyword) {
      activeFiltersList.append(
        `<div class="filter-tag">${keyword} <button type="button" class="remove-keyword"><img src="${theme_vars.template_directory}/assets/images/icons/x.svg" alt="Remove filter"></button></div>`
      );
    }

    $('#active-filters').toggle(selectedTypes.length > 0 || !!keyword);
  }

  function removeFilter(type) {
    const typesSelect = $('#types-select');
    const newValues = (typesSelect.val() || []).filter(val => val !== type);
    typesSelect.val(newValues).trigger('change');
    updateActiveFilters();
    $('#search-btn').trigger('click');
  }

  function removeKeyword() {
    $('#keyword-input').val('');
    updateActiveFilters();
    $('#search-btn').trigger('click');
  }

  // --- Wishlist Functionality ---
  function getSavedItems() {
    return JSON.parse(localStorage.getItem('savedItems')) || [];
  }

  function updateSavedIcons() {
    const savedItems = getSavedItems();
    $('.like').each(function () {
      const $button = $(this);
      const postId = $button.attr('data-id');
      if (!postId) return;
      const isSaved = savedItems.includes(postId);

      // Update button text based on saved state
      const $text = $button.find('span');
      if ($text.length) {
        $text.text(isSaved ? 'Retirer de ma sélection' : 'Ajouter à ma sélection');
      }

      // Update icon appearance
      updateLikeButton($button, isSaved);
    });
  }

  function toggleSaveItem(postId) {
    let savedItems = getSavedItems();
    let message = '';
    const index = savedItems.indexOf(postId);
    let wasAdded = false;

    if (index === -1) {
      savedItems.push(postId);
      message = "Ajouté à la liste d'envies";
      wasAdded = true;
    } else {
      savedItems.splice(index, 1);
      message = "Retiré de la liste d'envies";
      wasAdded = false;
    }
    localStorage.setItem('savedItems', JSON.stringify(savedItems));

    if (message) {
      $('<div class="toast like-toast">' + message + '</div>')
        .appendTo('body')
        .delay(2000)
        .fadeOut(300, function () {
          $(this).remove();
        });
    }

    if ($('#wishlist-grid').length) {
      loadWishlist(1);
    }

    return wasAdded;
  }

  function loadWishlist(page = 1) {
    const wishlistGrid = $('#wishlist-grid');
    if (!wishlistGrid.length) return;

    const wishlistContainer = $('#wishlist-section.results-section .container');
    const wishlistPagination = $('#wishlist-pagination');
    const savedItems = getSavedItems().filter(id => id && id > 0);

    wishlistGrid.empty();
    wishlistPagination.empty();
    wishlistContainer.find('.no-items, .error').remove();

    if (savedItems.length === 0) {
      wishlistContainer.prepend('<div class="no-items">Aucun élément dans votre liste de souhaits.</div>');
      return;
    }

    const $loading = $('<div class="loading"><img src="' + theme_vars.template_directory + '/assets/images/icons/loading.svg" alt="Chargement..."></div>').prependTo(wishlistContainer);

    $.ajax({
      url: wishlist_vars.ajax_url,
      type: 'POST',
      data: { action: 'get_wishlist', page, saved_ids: savedItems, nonce: wishlist_vars.nonce },
      success: function (response) {
        if (response.success) {
          wishlistGrid.html(response.data.grid || '');
          wishlistPagination.html(response.data.pagination || '');
          const url = new URL(window.location.href);
          if (response.data.current_page > 1) url.searchParams.set('page', response.data.current_page);
          else url.searchParams.delete('page');
          window.history.pushState({ page: response.data.current_page }, '', url);
          updateSavedIcons(); // Update icons after loading content
        } else {
          wishlistGrid.html('<div class="error">Une erreur s\'est produite lors du chargement de votre liste de souhaits.</div>');
        }
      },
      error: function (xhr, status, error) {
        wishlistGrid.html('<div class="error">Erreur: ' + (error || 'Une erreur inconnue est survenue') + '</div>');
        console.error('Wishlist AJAX Error:', status, error);
      },
      complete: function () {
        $loading.remove();
      },
    });
  }

  // --- Initialization and Event Handlers ---
  // Run updateSavedIcons when the document is ready
  $(document).ready(function () {
    updateSavedIcons();
  });

  // Also run updateSavedIcons when AJAX content is loaded
  $(document).ajaxComplete(updateSavedIcons);

  // Helper function to update a single like button
  function updateLikeButton($button, isSaved) {
    const path = $button.find('path');
    if (!path.length) return;

    $button.toggleClass('liked', isSaved);
    path.attr('fill', isSaved ? '#ED4244' : 'none');
    path.attr('stroke', isSaved ? '#ED4244' : '#454545');
  }

  $(document.body).on('click', '.like', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $button = $(this);
    const wasSaved = toggleSaveItem($button.attr('data-id'));
    updateLikeButton($button, wasSaved);
  });

  if ($('#wishlist-grid').length) {
    const initialPage = new URLSearchParams(window.location.search).get('page') || 1;
    window.history.replaceState({ page: initialPage }, '', window.location.href);
    loadWishlist(initialPage);

    $(document).on('click', '#wishlist-pagination .page-link', function (e) {
      e.preventDefault();
      const page = $(this).data('page');
      if (page && !$(this).hasClass('active')) loadWishlist(page);
    });

    window.onpopstate = function (event) {
      loadWishlist((event.state && event.state.page) || 1);
    };
  }

  // --- Other Functionality ---
  $('.show-cart-btn').on('click', function (e) {
    e.preventDefault();
    $('.checkout-cart-content').show();
    $('.hide-cart-btn').css('display', 'flex');
    $(this).hide();
  });

  $('.hide-cart-btn').on('click', function (e) {
    e.preventDefault();
    $('.checkout-cart-content').hide();
    $('.show-cart-btn').css('display', 'flex');
    $(this).hide();
  });

  $('.download-content-btn').on('click', function (e) {
    e.preventDefault();
    const $btnWrap = $('.download-content-btn-wrap').hide();
    html2canvas($('.checkout-process')[0], { scale: window.devicePixelRatio || 2, useCORS: true, backgroundColor: '#ffffff' })
      .then(canvas => {
        const link = document.createElement('a');
        link.download = 'recapitulatif-commande-' + Date.now() + '.png';
        link.href = canvas.toDataURL('image/png', 1.0);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(error => {
        console.error('Error generating image:', error);
        alert("Erreur lors de la génération de l'image. Veuillez réessayer.");
      })
      .finally(() => {
        $btnWrap.show();
      });
  });

  $(document).on('click', '.toggle-content-btn', function () {
    const $wrapper = $(this).closest('.toggle-content-wrapper');
    const isMore = $(this).data('toggle') === 'more';
    $wrapper.find('.toggle-content-short').toggle(!isMore);
    $wrapper.find('.toggle-content-full').toggle(isMore);
    $(this)
      .text(isMore ? 'Lire moins' : 'Lire plus')
      .data('toggle', isMore ? 'less' : 'more');
  });
});
